import { FC } from 'react';
import styles from './styles.module.css';

export const SymbolInCircle: FC<{ blok: { symbol: string } }> = ({ blok }) => {
  return <div className={styles.symbolInCircle}>{blok.symbol}</div>;
};
